import { gql } from '@apollo/client';

export const FIND_CONFIG_SYSTEM_BY_KEY = gql`
  query ConfigSystem_findByKey($key: String!) {
    ConfigSystem_findByKey(key: $key) {
      id
      value
      valueType
      key
      configSystemHistories {
        id
        configSystemId
        key
        valueType
        previousValue
        newValue
        action
        createdAt
        createdBy
      }
    }
  }
`;

export const UPDATE_VALUE_CONFIG_SYSTEM = gql`
  mutation ConfigSystem_updateValue($input: UpdateConfigSystemInput!) {
    ConfigSystem_updateValue(updateConfigSystemInput: $input) {
      id
      value
      valueType
      key
    }
  }
`;

export const CREATE_CONFIG_SYSTEM = gql`
  mutation ConfigSystem_create($input: CreateConfigSystemInput!) {
    ConfigSystem_create(createConfigSystemInput: $input) {
      id
      value
      valueType
      key
    }
  }
`;

export const UPDATE_SALES_TARGET_RANKING = gql`
  mutation ConfigSystem_updateSalesTargetRankingConfiguration(
    $input: [RankingConfigurationInput!]!
  ) {
    ConfigSystem_updateSalesTargetRankingConfiguration(input: $input) {
      id
    }
  }
`;
